import { environment } from 'src/environments/environment';
import { Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { LoaderService } from '../services/loader.service';
import { BpSnackbarService } from '../services/bp-snack-bar.service';
import { pageView, sendEvent } from 'src/app/shared/utils/tag-manager';

export class GeneralUtils {
    public environment = environment;
    public route: ActivatedRoute;
    public router: Router;
    public breakpointObserver: BreakpointObserver;
    public unsubscribe$: Subject<void>;
    public auth: AuthService;
    public loader: LoaderService;
    public snackbar: BpSnackbarService;
    public pageView = pageView;
    public sendEvent = sendEvent;

    constructor(injector: Injector) {
        this.route = injector.get(ActivatedRoute);
        this.router = injector.get(Router);
        this.auth = injector.get(AuthService);
        this.breakpointObserver = injector.get(BreakpointObserver);
        this.loader = injector.get(LoaderService);
        this.unsubscribe$ = new Subject();
        try {
            this.snackbar = injector.get(BpSnackbarService);
        } catch (error) {
            console.warn('The MatSnackbarModule is not imported');
        }
    }

    // tslint:disable-next-line: typedef
    get regEx() {
        return {
            amex: /^3[47][0-9]{13}$/,
            mastercard: /(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}/,
            visa: /^4[0-9]{12}(?:[0-9]{3})?/,
            discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
            jcb: /^(3(?:088|096|112|158|337|5(?:2[89]|[3-8][0-9]))\d{12})$/,
            dinners_club: /^3(?:0[0-5]|[68][0-9])[0-9]/,
            email: /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/,
            curp: /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
            rfc: /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/
        };
    }

    // tslint:disable-next-line: typedef
    get mask() {
        return {
            creditCard: '0000 0000 0000 0009',
            expiration: '00/00',
            cvv: '0009',
            clabe: '000000 000000 000000',
            tel: '(000) 000 0000',
            zipCode: '00000',
            bpKey: 'AAAA-AAAA-AAAA-AAAA'
        };
    }

    public unsubscribeAll(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    public maskPhoneSeparator(phone: string): string {
        return /^(55|33|81)/.test(phone) ? '(00) 0000 0000' : '(000) 000 0000';
    }

    public setTitlePage(title?: string): void {
        document.title = title ? `${title} - Billpocket` : 'Billpocket';
    }
}
